<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6GLIAZ/cover.jpeg?1685203881422" alt="This image is the cover for the book I'm the Legitimate Wife, Volume 1"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">I'm the Legitimate Wife, Volume 1
      </h1>
      <p class="bookDescription body article font2">
        <p>Xu Mingwei was her name in this life. As the direct daughter of a noble family, her life was decided from the moment she was born. Growing up in the family, he married a man who was on the same side of the family. He made him his first wife, gave him children, and took care of his concubines in the backyard. For Xu Mingwei, who was educated under her legal wife, these were all things she could do easily. If one were to look back and see that she and Fu Heng had been married for five years, they would see that she had a pair of adorable children and a roomful of cuticles. From the beginning, she had never wished for such things like feelings. Unexpectedly, her husband suddenly asked her about this. If she didn't have it, how could she give it to him?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mockangle, Lemon Novel
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Funstory
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8bef3bea